export enum ArtifactTypes {
    SCRIPT = 'scripts',
    TEMPLATE = 'templates',
    PLUGIN = 'plugin',
    MACRO = 'macro',
    PROPERTY = 'properties',
    ENDPOINT = 'endpoints'
}
